import searchGif from "../../../assets/icons/search.gif";
import { products } from "../../../constants/products";
import { UpsellCardBase } from "../../../components/UpsellCardBase";

export const DiscoveryRequestUpsellCard: React.FC = ({}) => {
  const key = "discovery_manager";
  const product = products[key];
  if (!product) return null;

  return (
    <UpsellCardBase
      productKey={key}
      title="Discovery Requests"
      description="Stay ahead on discovery deadlines. Upload discovery requests, break them into actionable tasks, and stay organized with document uploads for each response. Our tools make it easy to track progress, manage evidence, and meet deadlines without the stress."
      imageSrc={searchGif}
      price={product.price}
    />
  );
};
